import { HttpError } from "@refinedev/core";
import { useTable } from "@refinedev/react-table";

import { DataTable } from "@/components/refine-ui/data-table/data-table";
import { DataTableActionBar } from "@/components/refine-ui/data-table/data-table-action-bar";
import { ListView } from "@/components/refine-ui/views/list-view";
import { useArtistsColumns } from "@/pages/artists/hooks/use-columns";
import { IArtistData } from "@/types/artist";

export const ArtistsList = () => {
  const columns = useArtistsColumns();
  const defaultQueryBy =
    "enrichment.transliterations.el,enrichment.transliterations.en,name";

  const table = useTable<IArtistData, HttpError>({
    columns,
    enableColumnResizing: true,
    columnResizeMode: "onChange",
    initialState: {
      columnVisibility: { id: false },
    },
    refineCoreProps: {
      meta: {
        defaultQueryBy: defaultQueryBy,
      },
      sorters: {
        initial: [
          {
            field: "createdAt",
            order: "desc",
          },
        ],
      },
      pagination: {
        pageSize: 25,
      },
    },
    meta: {
      querySuggestions: [
        {
          id: "status",
          label: "status",
        },
      ],
    },
  });

  return (
    <ListView>
      <DataTableActionBar resource="artists" table={table} />
      <DataTable table={table} />
    </ListView>
  );
};
